'use client';
import React from 'react';
import { MALANG_AREAS } from '@/data/mockCafes';

interface Props {
  selected: string;
  onChange: (area: string) => void;
}

export default function AreaTabs({ selected, onChange }: Props) {
  return (
    <div className="flex gap-2 overflow-x-auto scrollbar-hide pb-1">
      {MALANG_AREAS.map((area) => (
        <button
          key={`area-${area}`}
          onClick={() => onChange(area)}
          className={`flex-shrink-0 px-4 py-1.5 rounded-full text-xs font-600 border transition-all ${
            selected === area
              ? 'bg-primary text-white border-primary' :'bg-card border-border text-muted-foreground hover:border-primary hover:text-primary'
          }`}
        >
          {area}
        </button>
      ))}
    </div>
  );
}